import React from 'react';
import { getIsNewsEpisode } from '@24i/nxg-sdk-photon';
import { useTranslation } from 'react-i18next';
import { formatReleaseDateTime } from '@24i/nxg-core-utils';
import TextWithSeparator, { SEPARATORS, } from '@24i/nxg-sdk-smartott/src/components/TitleView/components/TextWithSeparator';
import { SubTitle } from '../../styled';
export const SubtitleWithText = ({ asset, theme, renderedSubtitle }) => {
    const isNewsEpisode = getIsNewsEpisode(asset);
    const { i18n } = useTranslation();
    const assetReleaseDate = isNewsEpisode && asset.releaseDateTime
        ? formatReleaseDateTime(asset.releaseDateTime, i18n.language, 'date-only')
        : null;
    return (React.createElement(SubTitle, { theme: theme }, assetReleaseDate ? (React.createElement(TextWithSeparator, { separator: SEPARATORS.DOT, variant: "secondaryColor" },
        assetReleaseDate,
        renderedSubtitle)) : (renderedSubtitle)));
};
//# sourceMappingURL=index.js.map